
import ProductThumbnail from './components/ProductThumbnail';

export default {
  i18nComponentKey: 'WidgetProductsProductThumbnail.WidgetProductsProductThumbnailMobile',
  name: 'WidgetProductsProductThumbnailMobile',
  components: { ProductThumbnail }
};
